import { render, staticRenderFns } from "./StockIn.vue?vue&type=template&id=fff4daac&scoped=true"
import script from "./StockIn.vue?vue&type=script&lang=js"
export * from "./StockIn.vue?vue&type=script&lang=js"
import style0 from "./StockIn.vue?vue&type=style&index=0&id=fff4daac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff4daac",
  null
  
)

export default component.exports